import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/vercel/path0/components/marketing-tivion/navigation.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.11_@babel+core@7.28.5_@playwright+test@1.58.1_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
